import dayjs from 'dayjs';
export { default } from 'dayjs';
import 'dayjs/locale/en-gb';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.locale('en-gb');
dayjs.extend(localizedFormat);
